import { BrandMark } from "@/components/shared/brand-mark";
import { cn } from "@/lib/utils";

/* Identidad SCP compartida con los iconos del navegador y los accesos moviles. */
export function Logo({
  compact = false,
  light = false,
  size = "avatar-lg",
}: {
  compact?: boolean;
  light?: boolean;
  size?: string;
}) {
  return (
    <span className="d-inline-flex align-items-center">
      <span className={cn("avatar h-auto", size, !compact && "mr-12pt")}>
        <span className="avatar-title rounded bg-primary">
          <BrandMark />
        </span>
      </span>
      {!compact && (
        <span className="d-flex flex-column">
          <strong className={cn("brand h4 mb-0", light && "text-white")}>
            SCP
          </strong>
          <small className={cn("text-50", light && "text-white-50")}>
            Capacitacion institucional
          </small>
        </span>
      )}
    </span>
  );
}
